import type { LoadState } from "@redotech/react-util/load";
import type { ReturnsOnboardingResumeState } from "./returns-onboarding-resume-state";

export function visibleReturnsOnboardingResumeState({
  returnsEnabled,
  state,
}: {
  returnsEnabled: boolean;
  state: LoadState<ReturnsOnboardingResumeState>;
}): NonNullable<ReturnsOnboardingResumeState> | undefined {
  if (
    returnsEnabled ||
    state.pending ||
    state.error ||
    !state.value ||
    state.value.status === "completed"
  ) {
    return undefined;
  }
  return state.value;
}
